const styles = {
  container: {
    paddingX: '4.5rem',
    paddingY: '5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },
  cuitPaper: { padding: '1.5rem' },
  titleStyle: {
    display: 'flex',
    flexWrap: 'wrap',
    lineHeight: 'normal',
    flexDirection: 'column',
    textAlign: 'left',
  },
  containerAreaMovements: (responsive) => ({
    flexDirection: 'row',
    display: 'flex',
    gap: '0.5rem',
    flexWrap: responsive ? 'wrap' : 'nowrap',
  }),
  spinner: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    color: 'primary',
    margin: '5rem auto',
  },
};

export default styles;
